import { FC, useEffect, useMemo, useState } from "react";
import { useRecoilValue } from "recoil";
import { getImportJobs } from "../../../api/inventoryImport";
import { ImportJob } from "../../../models/import-job";
import { LpFilter } from "../../../models/lp-filter";
import { accountDataState } from "../../../recoil/account";
import { useQuery } from "../../../utils";
import { Header } from "../../shared";
import { JobStatus } from "./ImportInventoryHistory";

const ImportJobDetail: FC = () => {
    const accountInfo = useRecoilValue(accountDataState)
    const adminId = useMemo(() => {
        if (accountInfo.loginSession.userLocalType === 'ADMIN')
            return accountInfo.doctor.mId
    }, [accountInfo])

    const query = useQuery();
    const productId: string = query.get("jobId") || "";

    const [importJob, setImportJob] = useState<ImportJob | null>(null)

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (!adminId
                    || !productId) {
                    return;
                }

                let tempFilter: LpFilter = {
                    where: {
                        mId: productId
                    },
                    include: [
                        {
                            relation: 'mImportJobLogs'
                        }
                    ]
                }

                let jobData = await getImportJobs(parseInt(adminId), tempFilter);
                if (jobData.data.length > 0) {
                    setImportJob(jobData.data[0]);
                }
            } catch (err) {
                console.error("cannot fetch data: ", err);
            }
        }

        console.log("fetch data");
        fetchData()
    }, [adminId])

    const JobStatusUI = () => {
        if (!importJob) return <div></div>

        if (importJob.mStatus == JobStatus.onGoing) {
            return <div className="ml-auto">
                <img alt="none" src="./images/processing.svg" width="18" className="mr-1" />
                <span className="txt-black">Đang xử lý</span>
            </div>
        } else if (importJob.mStatus === JobStatus.done) {
            if (importJob.mTotalLines > (importJob.mTotalInStock + importJob.mTotalOutStock)) {
                return <div className="ml-auto">
                    <img alt="none" src="./images/report_problem.svg" width="18" className="mr-1" />
                    <span className="txt-black">Có lỗi</span>
                </div>
            } else {
                return <div className="ml-auto">
                    <img alt="none" src="./images/success.svg" width="18" className="mr-1" />
                    <span className="txt-black">Thành công</span>
                </div>
            }
        }
        return <div></div>
    }

    const ServerErrors = () => {
        if (!importJob
            || !importJob.mImportJobLogs
            || importJob.mImportJobLogs.length == 0) {
            return <div></div>
        }

        let maps = importJob.mImportJobLogs.map((error, index) => {

            if (error.mNote.includes("lineNumber")) {
                let noteData: any = JSON.parse(error.mNote);

                return <div className="alert alert-danger" key={index}>
                    <img alt="none" src="./images/report_problem.svg" title="Error" className="img-fluid" width="24" />
                    <span>{`Lỗi ở dòng số ${noteData.lineNumber}. ID sản phẩm: ${noteData.data['ID sản phẩm']}. Nội dung: ${noteData.error.vi ? noteData.error.vi.message : noteData.error.message}`}</span>
                </div>
            } else {
                return <div className="alert alert-danger" key={index}>
                    <img alt="none" src="./images/report_problem.svg" title="Error" className="img-fluid" width="24" />
                    <span>{error.mNote}</span>
                </div>
            }
        })

        return <div>{maps}</div>
    }

    return (
        <div className="w-100">
            {
                importJob ?
                    <div>
                        <Header
                            title={`File ID${importJob.mId}`}
                            subTitle={new Date(importJob.mCreated).toLocaleDateString('vi', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                            backTo="/admin-dashboard?dashboardTabId=4&importTabId=history"
                        />

                        <div id="main">
                            <div className="container">
                                <div className="pt-4">
                                    <div className="d-flex mb-3">
                                        <span className="txt-gray">Nhà thuốc</span>
                                        <div className="ml-auto">
                                            <span className="txt-black">{importJob.mPharmacyName}</span>
                                        </div>
                                    </div>
                                    <div className="d-flex mb-3">
                                        <span className="txt-gray">Trạng thái</span>
                                        <JobStatusUI />
                                    </div>
                                    <div className="d-flex mb-3">
                                        <span className="txt-gray">Người tải</span>
                                        <div className="ml-auto">
                                            <span className="txt-black">{importJob.mUploaderName}</span>
                                        </div>
                                    </div>
                                    <div className="d-flex mb-3">
                                        <span className="txt-gray">Tên file</span>
                                        <div className="ml-auto">
                                            <span className="txt-black">{importJob.mFileName}</span>
                                        </div>
                                    </div>
                                    <hr />
                                    <p className="d-flex w-100 justify-content-between">
                                        <span>Số lượng sản phẩm</span>
                                        <span>{new Intl.NumberFormat().format(importJob.mTotalLines)}</span>
                                    </p>
                                    <p className="d-flex w-100 justify-content-between">
                                        <span>Còn hàng</span>
                                        <span>{new Intl.NumberFormat().format(importJob.mTotalInStock)}</span>
                                    </p>
                                    <p className="d-flex w-100 justify-content-between">
                                        <span>Hết hàng</span>
                                        <span>{new Intl.NumberFormat().format(importJob.mTotalOutStock)}</span>
                                    </p>
                                    <ServerErrors />
                                </div>


                            </div>
                        </div>
                    </div>
                    : ''
            }
        </div>
    )
}

export default ImportJobDetail;